import React from 'react';

const Datelocale = (props) => {
    let date = new Date(props.date);

    return (
            <>
                {date.toLocaleDateString()}
            </>
        );

}

export default Datelocale;